"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var ClauseValueType_1 = require("../../store/schema/ClauseValueType");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
exports.default = legacy_1.action('setClauseErrorText')(function setClauseErrorText(clauseId, isValidClause) {
    var clause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
    var errorText;
    if (isValidClause) {
        store_1.default.inboxRulesEditState.clauseErrorTextMap.set(clauseId, '');
        return;
    }
    if (clauseId == 'name') {
        store_1.default.inboxRulesEditState.clauseErrorTextMap.set(clauseId, owa_options_strings_1.default.options_inboxRules_emptyNameError);
        return;
    }
    switch (clause.clauseType) {
        case 'from':
            errorText = owa_options_strings_1.default.options_inboxRules_emptyFromError;
            break;
        case 'to':
            errorText = owa_options_strings_1.default.options_inboxRules_emptyToError;
            break;
        case 'subjectIncludes':
        case 'subjectOrBodyIncludes':
        case 'inTheBody':
        case 'inTheSenderAddress':
        case 'inTheRecipientAddress':
        case 'inTheMessageHeader':
            errorText = owa_options_strings_1.default.options_inboxRules_emptyPhraseError;
            break;
        case 'atLeast':
        case 'atMost':
            errorText = getMessageSizeErrorText(Number(clause.clauseValue));
            break;
        default:
            errorText = owa_options_strings_1.default.options_inboxRules_emptyDropdownError;
            break;
    }
    store_1.default.inboxRulesEditState.clauseErrorTextMap.set(clauseId, errorText);
});
function getMessageSizeErrorText(num) {
    if (isNaN(num) || num < 1) {
        return owa_options_strings_1.default.options_inboxRules_messageSizeNotANumber;
    }
    else if (num > ClauseValueType_1.MAX_MESSAGE_SIZE / ClauseValueType_1.KB_TO_B) {
        return owa_options_strings_1.default.options_inboxRules_messageSizeTooLarge;
    }
    else {
        return '';
    }
}
//# sourceMappingURL=setClauseErrorText.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/setClauseErrorText.js
// module id = 3179
// module chunks = 2